import React from 'react';
import { Award, Building, Target, Heart, MapPin, Clock } from 'lucide-react';
import { whyChooseUs } from '../data/mock';

const iconMap = {
  Award,
  Building,
  Target,
  Heart,
  MapPin,
  Clock
};

const WhyChooseUs = () => {
  return (
    <section className="py-24 bg-bg-page">
      <div className="container mx-auto px-4 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="heading-2 text-white mb-6">
            Por Que Escolher o Centro de Lutas?
          </h2>
          <p className="body-large text-gray-300 max-w-3xl mx-auto text-xl">
            Não somos mais uma academia comum. Aqui você encontra treino sério, técnica real e uma comunidade que te apoia.
          </p>
        </div>

        {/* Reasons Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {whyChooseUs.map((item) => {
            const Icon = iconMap[item.icon];
            const getUniqueBg = (title) => {
              const t = title.toLowerCase();
              if (t.includes('professor')) return 'martial_arts_hero_premium_1774630170837.png';
              if (t.includes('estrutura')) return 'gym_equipment_texture_bg_1774630346701.png';
              if (t.includes('treino real')) return 'muay_thai_action_v2_1774630267798.png';
              if (t.includes('acolhedor')) return 'welcoming_gym_community_bg_1774631532611.png';
              if (t.includes('localização')) return 'subtle_gym_texture_bg_1774630285219.png';
              if (t.includes('horários')) return 'kickfit_subtle_bg_v2_1774632275520.png';
              return 'subtle_gym_texture_bg_1774630285219.png';
            };

            return (
              <div
                key={item.id}
                className="relative p-8 glass-card border-white/5 rounded-2xl hover:border-brand-primary group transition-all duration-300 overflow-hidden min-h-[300px]"
              >
                {/* Unique Background Image */}
                <div 
                  className="absolute inset-0 opacity-20 group-hover:opacity-40 transition-opacity duration-500 bg-cover bg-center grayscale"
                  style={{ backgroundImage: `url('${getUniqueBg(item.title)}')` }}
                ></div>

                <div className="relative z-10 h-full flex flex-col">
                  {/* Icon with background */}
                  <div className="relative w-16 h-16 bg-brand-primary rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 group-hover:rotate-3 transition-all duration-300 shadow-lg">
                    <Icon className="w-8 h-8 text-white" />
                  </div>
                  
                  {/* Content */}
                  <h3 className="heading-5 text-white mb-3 text-xl font-bold">
                    {item.title}
                  </h3>
                  <p className="body-small text-gray-400 text-base leading-relaxed">
                    {item.description}
                  </p>
                  
                  {/* Corner accent */}
                  <div className="absolute top-0 right-0 w-20 h-20 bg-brand-primary/10 rounded-bl-full opacity-50 -z-10"></div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
